import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { CompareActionMenu } from '@modules/quantify/components/CompareActionButton/CompareActionMenu';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { trackQuantifyCompareEvents } from '@modules/quantify/utils';
import { CompareArrowsRounded } from '@mui/icons-material';
import { Box, Button, Divider, Stack, alpha } from '@mui/material';
import { useState } from 'react';

export const CompareActionButton = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const isDisabled = useQuantifyStore(
    ({ visual, query }) => visual.isTableQueryInProgress || !query.groupBy,
  );
  const isActive = useQuantifyStore(({ query }) => Boolean(query.compareTo));

  const analysisLink = useAnalysisStore(({ href }) => href);

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    trackQuantifyCompareEvents({
      eventName: 'Quantify Compare - Compare Button Clicked',
      link: analysisLink,
    });
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const isMenuOpen = Boolean(anchorEl);

  return (
    <Box>
      <Stack direction="row" ml={4} mt="-24px">
        <Divider
          flexItem
          orientation="vertical"
          color="divider"
          sx={{
            height: `24px !important`,
            width: '3px',
          }}
        />
      </Stack>
      <Button
        data-testid="compare-button"
        variant="outlined"
        color="info"
        startIcon={<CompareArrowsRounded />}
        onClick={openMenu}
        sx={{
          backgroundColor:
            isMenuOpen || isActive
              ? (theme) => alpha(theme.palette.info.main, 0.1)
              : undefined,
        }}
        disabled={isDisabled}
      >
        Compare
      </Button>
      <CompareActionMenu anchorEl={anchorEl} closeMenu={closeMenu} />
    </Box>
  );
};
